import { getAuth } from 'firebase/auth';
import { isStoredSessionStale } from 'features/auth/utils/lastActivity';
import { ApplicationError } from 'features/error-handling/ApplicationError';
import { isFirebasePermissionDeniedError } from 'features/error-handling/errorUtils';
import { logger } from 'features/logger/logger';

const isPermissionDenied = (error: unknown): boolean =>
  (error instanceof ApplicationError && error.code === 'PHW-F-001') ||
  isFirebasePermissionDeniedError(error);

/**
 * Logs a snapshot listener error. Permission-denied with no Firebase user
 * signed in is quiet: `debug` while the stored session is stale (every logout
 * marks it stale), `warn` otherwise. Returns whether the error was quiet.
 */
export const logListenerError = (message: string, error: Error): boolean => {
  if (isPermissionDenied(error) && getAuth().currentUser === null) {
    if (isStoredSessionStale()) {
      logger.debug(message, undefined, error);
    } else {
      logger.warn(message, undefined, error);
    }

    return true;
  }

  logger.error(message, undefined, error);
  return false;
};
